import React from 'react';
import { Layout, Menu, Button, Space, Typography } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { 
  UserOutlined, 
  FileAddOutlined, 
  SearchOutlined, 
  TeamOutlined, 
  FileTextOutlined,
  LogoutOutlined,
  WechatOutlined,
  HomeOutlined,
  AppstoreOutlined,
  TagsOutlined,
  ScanOutlined
} from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';

const { Header } = Layout;
const { Text } = Typography;

const AppHeader = () => {
  const { currentUser, logout, isAdmin } = useAuth();
  const location = useLocation();
  
  // 根据当前路径确定选中的菜单项
  const getSelectedKey = () => {
    const path = location.pathname;
    if (path === '/' || path === '') return 'home';
    if (path.startsWith('/admin')) return 'admin';
    if (path.startsWith('/submit')) return 'submit';
    if (path.startsWith('/query')) return 'query';
    if (path.startsWith('/customers')) return 'customers';
    if (path.startsWith('/logs')) return 'logs';
    if (path.startsWith('/wx-pusher')) return 'wx-pusher';
    if (path.startsWith('/pattern-management')) return 'pattern-management';
    if (path.startsWith('/pattern-categories')) return 'pattern-categories';
    if (path.startsWith('/pattern-search')) return 'pattern-search';
    return '';
  };

  // 菜单项配置
  const allMenuItems = [
    {
      key: 'home',
      icon: <HomeOutlined />,
      label: <Link to="/">主页</Link>,
      visible: true
    },
    {
      key: 'admin',
      icon: <UserOutlined />,
      label: <Link to="/admin">用户管理</Link>,
      visible: isAdmin()
    },
    {
      key: 'submit',
      icon: <FileAddOutlined />,
      label: <Link to="/submit">提交运单</Link>,
      visible: true
    },
    {
      key: 'query',
      icon: <SearchOutlined />,
      label: <Link to="/query">查询记录</Link>,
      visible: true
    },
    {
      key: 'customers',
      icon: <TeamOutlined />,
      label: <Link to="/customers">客户管理</Link>,
      visible: true
    },
    {
      key: 'logs',
      icon: <FileTextOutlined />,
      label: <Link to="/logs">系统日志</Link>,
      visible: isAdmin()
    },
    {
      key: 'wx-pusher',
      icon: <WechatOutlined />,
      label: <Link to="/wx-pusher">微信推送</Link>,
      visible: isAdmin()
    },
    {
      key: 'pattern-management',
      icon: <AppstoreOutlined />,
      label: <Link to="/pattern-management">样板管理</Link>,
      visible: isAdmin()
    },
    {
      key: 'pattern-categories',
      icon: <TagsOutlined />,
      label: <Link to="/pattern-categories">样板分类</Link>,
      visible: isAdmin()
    },
    {
      key: 'pattern-search',
      icon: <ScanOutlined />,
      label: <Link to="/pattern-search">样板搜索</Link>,
      visible: true
    }
  ];
  
  // 过滤可见菜单项，并移除visible属性
  const menuItems = allMenuItems
    .filter(item => item.visible)
    .map(({ visible, ...item }) => item);

  return (
    <Header style={{ position: 'sticky', top: 0, zIndex: 1, width: '100%', display: 'flex', alignItems: 'center' }}>
      <div className="logo">📦 仓库管理系统</div>
      <Menu
        theme="dark"
        mode="horizontal"
        selectedKeys={[getSelectedKey()]}
        items={menuItems}
        style={{ flex: 1, minWidth: 0 }}
      />
      <Space style={{ marginLeft: 'auto' }}>
        <Text style={{ color: 'white' }}>
          {currentUser ? `${currentUser.username} (${currentUser.role === 'admin' ? '管理员' : '用户'})` : ''}
        </Text>
        <Button 
          type="text" 
          icon={<LogoutOutlined />} 
          onClick={logout}
          style={{ color: 'white' }}
        >
          退出登录
        </Button>
      </Space>
    </Header>
  );
};

export default AppHeader;
